import React, { useCallback } from "react";
import { toast } from "sonner";
import { UndoMenu } from "./UndoMenu";
import { CollectAllButton } from "./CollectAllButton";
import { LayoutsMenu } from "./LayoutsMenu";
import { useLayoutBridge } from "../lib/layoutBridge";
import { currentViewport, readPanelGeom, fitGeom } from "../lib/windowLayouts";
import {
  getDetachedPanels,
  closeAllDetachedPanels,
  openDetachedPanelsBatch,
} from "../lib/detachedPanels";

// FAZ F — 6 arayüzün üst barında ortak "GERİ AL" + "DÜZENLER" kontrolleri.
// Görevler paneli açıksa düzen mantığı ondan (köprü) gelir; kapalıysa yalnızca
// iş kolu pencereleri üzerinden yedek mantık çalışır.
export const TopBarMenus = ({ onRefresh, light = false }) => {
  const bridge = useLayoutBridge();

  const yedekTopla = useCallback(() => {
    const windows = getDetachedPanels()
      .filter((p) => p.category)
      .map((p, i) => {
        const g = readPanelGeom(p.id) || {};
        return {
          kind: "category",
          item_id: p.category,
          title: p.categoryName || null,
          x: g.x ?? 140, y: g.y ?? 90,
          width: g.width ?? 460, height: g.height ?? 620,
          z: 62 + i,
        };
      });
    return { viewport: currentViewport(), windows };
  }, []);

  const yedekUygula = useCallback(async (layout) => {
    const vp = currentViewport();
    const savedVp = layout.viewport || vp;
    const kollar = [];
    let atlanan = 0;
    for (const w of layout.windows || []) {
      if (w.kind !== "category") { atlanan += 1; continue; }
      kollar.push({ category: w.item_id, categoryName: w.title || null, geom: fitGeom(w, savedVp, vp) });
    }
    closeAllDetachedPanels();
    if (kollar.length) openDetachedPanelsBatch(kollar);
    if (atlanan > 0) {
      toast(`${atlanan} görev/alt görev penceresi açılamadı`, {
        description: "Görev pencereleri için Görevler panelini açın.",
        duration: 6000,
      });
    } else {
      toast.success(`"${layout.name}" düzeni uygulandı`);
    }
  }, []);

  const collect = bridge?.collect || yedekTopla;
  const apply = bridge?.apply || yedekUygula;
  const count = bridge
    ? bridge.count
    : getDetachedPanels().filter((p) => p.category).length;

  return (
    <div className="flex items-center gap-1 shrink-0" data-testid="topbar-menus">
      <UndoMenu onUndone={onRefresh} light={light} />
      <CollectAllButton light={light} />
      <LayoutsMenu
        collectWindows={collect}
        applyLayout={apply}
        openWindowCount={count}
        light={light}
      />
    </div>
  );
};

export default TopBarMenus;
